

import queryString from 'query-string';
import useNetwork from '@/hooks/useNetwork';
import useRouter from '@/hooks/useRouter';


export default function useStewardshipFilter(_props) {
  const { location } = useRouter();
  const query = queryString.parse(location.search);

  const network = useNetwork();

  if (query.networks === '0') {
    return [
    { networkId: network.id }
    // { published: true }
    ];
  }

  if (network) {
    return [
    { networkId: network.id }];

  }
};